import { useContext } from 'react';

import { SubscriptionContext } from '../contexts/SubscriptionContext';

export default () => useContext(SubscriptionContext);
